import type { FC } from 'react'
import { useEffect } from 'react'

import { Box } from '@mui/material'
import NProgress from 'nprogress'

const LoadingScreen: FC = () => {
  useEffect(() => {
    NProgress.start()

    return (): void => {
      NProgress.done()
    }
  }, [])

  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        minHeight: '100%',
      }}
    />
  )
}

export default LoadingScreen
